module.exports = __webpack_public_path__ + "img/settings.6f0c255a.svg";